import React, { useEffect, useState } from 'react';
import api from '../api';

const RATES = { ETH: 1770, BTC: 63035, USDT: 1 };

function Reports() {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    api.get('/api/assets/transactions')
      .then(res => setTransactions(res.data || []))
      .catch(err => console.error('Reports fetch error:', err));
  }, []);

  const deposits = transactions.filter(t => t.type === 'deposit');
  const releases = transactions.filter(t => t.type === 'release');

  // Total USD volume of all transactions
  const totalVolumeUSD = transactions.reduce((sum, tx) => {
    const rate = RATES[tx.currency] || 1770;
    return sum + (tx.amount || 0) * rate;
  }, 0);

  return (
    <div>
      <h2>Reports</h2>
      <div className="stat-cards" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
        <div className="card">
          <h3>Total Deposits</h3>
          <p>{deposits.length}</p>
        </div>
        <div className="card">
          <h3>Total Releases</h3>
          <p>{releases.length}</p>
        </div>
        <div className="card">
          <h3>All Transactions</h3>
          <p>{transactions.length}</p>
        </div>
        <div className="card">
          <h3>Total Volume (USD)</h3>
          <p>${totalVolumeUSD.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
        </div>
      </div>

      <h3 style={{ marginTop: '2rem' }}>Transaction Log</h3>
      <div className="table-box">
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.slice(0, 10).map(tx => (
              <tr key={tx.id}>
                <td style={{ color: tx.type === 'deposit' ? 'green' : 'red' }}>
                  {tx.type}
                </td>
                <td>{tx.amount}</td>
                <td>{tx.currency || 'ETH'}</td>
                <td>{new Date(tx.createdAt).toLocaleDateString()}</td>
                <td>{tx.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Reports;